"use client";

import { FileText, CircleCheck, Clock } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const cards = [
  {
    icon: FileText,
    title: "Información dispersa",
    description:
      "Correos, planillas y mensajes no dan visibilidad real.",
  },
  {
    icon: CircleCheck,
    title: "Brechas invisibles",
    description:
      "No siempre se sabe qué está vigente, vencido o incompleto.",
  },
  {
    icon: Clock,
    title: "Riesgo tardío",
    description:
      "Los problemas aparecen cuando ya impactan la operación.",
  },
];

export default function PainPoints() {
  return (
    <section id="learn-more" aria-label="Problemas que resuelve Verify" className="px-6 pt-16 sm:pt-20 pb-16 sm:pb-20">
      <div className="mx-auto max-w-[60rem] text-center mb-14">
        <ScrollReveal>
          <span className="inline-block rounded-full px-3.5 py-1 text-sm sm:text-base font-semibold text-accent mb-0">
            El problema
          </span>
        </ScrollReveal>
        <ScrollReveal delay={0.08}>
          <h2 className="flex flex-col text-balance font-medium text-[2rem] sm:text-[36px] lg:text-5xl tracking-[-0.02em] text-dark-teal leading-[1.1] sm:leading-none mb-4">
            <span>El cumplimiento no se supone.</span>
            <span className="text-[#a6a6ab] font-medium">Se verifica.</span>
          </h2>
        </ScrollReveal>
        <ScrollReveal delay={0.15}>
          <p className="text-pretty text-[.95rem] sm:text-[18px] leading-[1.6] text-dark-teal/50 max-w-[540px] mx-auto">
            La documentación crítica se dispersa entre correos, planillas y mensajes. El riesgo aparece cuando ya impactó la operación.
          </p>
        </ScrollReveal>
      </div>

      <div className="relative mx-auto max-w-[60rem]">
        {/* Subtle brand-colored dot pattern to support and refract through the glassmorphism */}
        <div
          className="absolute inset-[-40px] -z-10 opacity-[0.04] pointer-events-none [mask-image:radial-gradient(ellipse_at_center,black_40%,transparent_80%)]"
          style={{
            backgroundImage: "radial-gradient(var(--color-dark-teal) 1.5px, transparent 1.5px)",
            backgroundSize: "24px 24px"
          }}
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 relative z-10">
          {cards.map(({ icon: Icon, title, description }, i) => (
            <ScrollReveal key={title} delay={i * 0.1} className="h-full">
              <div className="group flex flex-col bg-white/60 backdrop-blur-md border border-white rounded-[24px] p-7 h-full transition-all duration-300 ease-[cubic-bezier(0.32,0.72,0,1)] ring-1 ring-dark-teal/[0.04] hover:ring-accent/30 hover:bg-white/80">
                <div className="w-11 h-11 flex items-center justify-center bg-white/80 backdrop-blur-sm rounded-xl border border-white ring-1 ring-dark-teal/[0.03] mb-5 transition-all duration-300 group-hover:ring-accent/20 group-hover:bg-white">
                  <Icon className="w-5 h-5 text-accent" strokeWidth={1.8} />
                </div>

                <h3 className="text-base sm:text-[18px] tracking-tight font-semibold text-dark-teal mb-2 transition-colors duration-300">
                  {title}
                </h3>

                <p className="text-[15px] leading-[1.65] text-dark-teal/65 flex-grow transition-colors duration-300 group-hover:text-dark-teal/85">
                  {description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
